import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule, ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-loading-spinner',
    standalone: true,
    imports: [CommonModule, MatProgressSpinnerModule, TranslocoModule],
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerComponent {
    @Input() loadingText: string | null = null;
    @Input() showLoadingText = true;
    @Input() diameter = 48;
    @Input() mode: ProgressSpinnerMode = 'indeterminate';
    @Input() containerClass = '';
    @Input() textClass = '';
}
